export default function footer() {
    return (
        <footer className="py-6 px-16 border-t border-gray-200 font-light text-gray-700 mb-6 lg:mb-0 text-sm text-center">

                Copyright &copy; {new Date().getFullYear()}{' '}
                <a
                    href="https://www.jeevee.com"
                    target="_blank"
                    rel="noreferrer"
                    className="text-light-blue-500 hover:text-light-blue-700"
                >
                    Jeevee
                </a>
                . All Rights Reserved.
        </footer>
    );
}
